module.exports = __webpack_public_path__ + "common/icon-document-fill-0d5c9425a6cf32cad54e835d419dc740.svg";